import styled from "styled-components/macro";

export const StyledLandingFooter = styled.footer`
  font-family: "Roboto", sans-serif;
  font-size: 1.3rem;
  font-weight: 500;

  align-self: end;
  padding: 0.8rem 0;
`;
